export enum PostTypeModel {
    NIGHT = "night",
    STAY = "stay"
}